import { createLineMarker } from 'app/core/markers/models';
import { InsertConvex } from './InsertConvex';
export const InsertLine = () => {
    const createMarker = (point) => createLineMarker({
        x: point.x,
        y: point.y,
    });
    return InsertConvex(createMarker);
};
